import { createRouter, createWebHashHistory } from 'vue-router';
import config from '../assets/script/config';

import Dashboard from '@/views/Dashboard.vue';
import MyProject from '@/views/MyProject.vue';
import CompleteProject from '@/views/CompleteProject.vue';
import ProjectTask from '@/views/ProjectTask.vue'
import MyTask from '@/views/MyTask.vue';
import TaskType from '@/views/TaskType.vue';

import Login from '@/views/Login';
import NoAuth from '@/views/NoAuth'

const routes = [{
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { keepalive: true, title: 'APPName' },
}, {
    path: '/myProject',
    name: 'myProject',
    component: MyProject,
    meta: { keepalive: true, title: 'APPName' },
}, {
    path: '/completeProject',
    name: 'completeProject',
    component: CompleteProject,
    meta: { keepalive: true, title: 'APPName' },
}, {
    path: '/myTask',
    name: 'myTask',
    component: MyTask,
    meta: { keepalive: true, title: 'APPName' },
}, {
    path: '/projectTask',
    name: 'projectTask',
    component: ProjectTask,
    meta: { keepalive: true, title: 'APPName' },
}, {
    path: '/completeProject',
    name: 'completeProject',
    component: CompleteProject,
    meta: { keepalive: true, title: 'APPName' },
}, {
    path: '/taskType',
    name: 'taskType',
    component: TaskType,
    meta: { keepalive: true, title: 'APPName' },
}, {
    path: '/',
    name: 'login',
    component: Login,
    meta: { keepalive: true, title: 'APPName' }
}, {
    path: '/noAuth',
    name: 'noAuth',
    component: NoAuth,
    meta: { keepalive: true, title: 'APPName' }
}
];

const router = createRouter({
    history: createWebHashHistory(),
    base: config.PBASE,
    routes
});

// const routerPush = VueRouter.prototype.push,
//     routerReplace = VueRouter.prototype.replace;

// VueRouter.prototype.push = function push (location) {
//     return routerPush.call(this, location).catch(error => error)
// }

// VueRouter.prototype.replace = function push (location) {
//     return routerReplace.call(this, location).catch(error => error)
// }

export default router;
